import React from "react";
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    Select,
    FormHelperText,
    Icon,
} from '@chakra-ui/react'
import { CustomSelectProps } from "../../../types/form";

export default function FormSelect({ 
    label, 
    value, 
    id, 
    size,
    errMsg, 
    isRequired,
    isDisabled,
    helperText,
    className,
    onChange,
    list,
    optionKey,
    optionLabelKey,
    optionChildren,
    labelProps,
    formControlProps,
    ...props
}: CustomSelectProps) {

    function computeOptionValue(item: any, key?: string): string | number | undefined { 
        let result = '';

        if (typeof item === 'string') {
            result = item;
            return result
        } 
        if (typeof item === 'object' && key) {
            result = item[key!]
            return result
        }        
        return result;
    }

    return (
        <FormControl 
            isInvalid={!!errMsg} 
            isRequired={isRequired}
            isDisabled={isDisabled}
            className={className}
            {...formControlProps}
        >
            <FormLabel 
                htmlFor={id} 
                fontSize={'sm' || labelProps?.fontSize} 
                color='rgba(51, 65, 85, 1)' 
                marginBottom={'0.5' || props?.marginBottom}
                {...labelProps}
            >
                {label}
            </FormLabel>
            <Select placeholder={props.placeholder} fontSize={props.fontSize || 'sm'}>
                {!list ? (
                    <option value='option1'>Add an option</option>
                ): (
                    list.map((item, index) => (
                        <option key={index} value={computeOptionValue(item, optionKey!)}>
                            {props.isIcon && (
                               <Icon as={props?.iconn!} fontSize='sm' /> 
                            )}
                            {computeOptionValue(item, optionLabelKey!)}
                        </option>  
                    ))
                )}
            </Select>
            {errMsg ? <FormErrorMessage>{errMsg}</FormErrorMessage> : null}         
            { helperText ? <FormHelperText>{helperText}</FormHelperText> : null }
        </FormControl>       
    )
}